var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDeviceMobile)?_c('base-mobile-menu',{attrs:{"items":_vm.menuItems,"shouldBgBeBlue":_vm.shouldBgBeBlue,"title":_vm.defaultTitle}}):(_vm.isDeviceDesktop)?_c('base-desktop-menu',{attrs:{"items":_vm.menuItems,"shouldBgBeBlue":_vm.shouldBgBeBlue,"title":_vm.defaultTitle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }